
  <template>
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border pa-0">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td  style="vertical-align:top;" width="30%">
                   <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                     <img class="leftsection" width="100%" :src="leftsection" >
                   </div>
                  </td>
                   <td colspan="2" width="70%" :style="{ 'vertical-align':'top', 'background-image': 'url(' + rightsection + ')','background-size':'100% 94%' }">
                            <div class="col-lg-12 col-md-12 draggablecontent" :style="{ 'background-image': 'url(' + adhere + ')' }"  >
                              <div class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                  </div>
                    </div> 
                    </td>  
                </tr>  
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
  </template>
 <script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Quizstartemplate',
    props:[
       'bannerposition',
       'bannercontentimage',
       'bannercontenthtml',
       'bannercontent',
       'bannerimage',
    ],
    components: {

        },
    data: () => ({
      leftsection : require("@/assets/quizstarleftsection.png"),
      rightsection :  require("@/assets/quizstarcentersection.png"),
      adhere: ''//require("@/assets/506.jpg"),
     }),
      mounted() {
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.header-content{width:100%;height: 46px;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;margin-top: 33%;width: 50%;margin-left: 25%;}
#bannercontentimage{width:100%;height:100%;position: relative;}
#bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.postionsection{width: 100%;height: 150px;}
.leftsection{}
</style>